import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss'

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import createBrowserHistory from 'history/createBrowserHistory';
import createStore from './store/Store';
import {restoreToken} from "./util/authentication";
import dayjs from "dayjs";

const history = createBrowserHistory();
const store = createStore(history);

require('dayjs/locale/ja')
dayjs.locale('ja')

restoreToken()

const render = () => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App history={history}/>
        </ConnectedRouter>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
render();
